import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import VideoPlayer from "../../../video/video_room/player/video_player";
import {attributesToProps, domToReact} from 'html-react-parser'
import VideoRoomTabs from "../../../video/video_room/widgets/video_room_tabs";
import RenderedHtmlContent from "../rendered_html_content";

const RenderedVideoRoomTabs = ({node, options}) => {

  const videoRooms = useSelector(state => state.videoRooms)
  const videoRoom = videoRooms?.find(vr => (node.attribs["data-videoroom-identifier"] && vr.identifier == node.attribs["data-videoroom-identifier"]) || (node.attribs["data-video-room-identifier"] && vr.identifier == node.attribs["data-video-room-identifier"]) || (node.attribs["data-video_room_identifier"] && vr.identifier == node.attribs["data-video_room_identifier"]))
  const hostname = useSelector(state => state.hostname)
  const questionsOptionsSortField = node.attribs["data-question-option-sortfield"]
  const questionsOptionsSortReverse = node.attribs["data-question-option-sort-reverse"]
  const questionsOptionsShowNames = node.attribs["data-question-option-show-names"] ? node.attribs["data-question-option-show-names"] == "true" : true
  const questionsShowCompany = node.attribs["data-questions-show-company"]


  if (!videoRoom) {
    return <div className={"alert alert-danger"}>
      NO VIDEO ROOM FOUND FOR VIDEO-ROOM DIV. No video rooms available in state.
    </div>
  }

  const tabs = {
    "flavecsr22": [
      {
        identifier: "wordcloud",
        label: "Wordcloud",
        hidden: !videoRoom?.word_cloud_enabled,
        render: () => {
          return <RenderedHtmlContent identifier={"video_room.wordclouds"} />
        }
      },
    ]
  }

  return <>
    <VideoRoomTabs 
      videoRoom={videoRoom}
      questionsShowCompany={questionsShowCompany ? questionsShowCompany == "true" : undefined}
      useBootstrapNavigation={true}
      hideNavigationIcons={true}
      additionalTabs={tabs[hostname] || []}
      questionsOptions={{ sortField: questionsOptionsSortField, reverse: questionsOptionsSortReverse, showNames: questionsOptionsShowNames }}
    />
  </>
}

export default RenderedVideoRoomTabs